import React from "react";
import bg from "./assets/internalImages/Enterprise/hero_section_bg_enterprise_.webp";
import front from "./assets/internalImages/Enterprise/hero_section_front_enterprise_.webp";
import truckBg from "./assets/internalImages/Driver Partner/_wodps_truck_bg.webp";
import truck from "./assets/internalImages/Driver Partner/_wodps_truck_.webp";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import "./DriverPartnerLogin.scss";

import KeyFeatures from "./Components/InternalPages/KeyFeatures";
import ClientReviews from "./Components/InternalPages/ClientReviews";
import IndustriesWeServe from "./Components/InternalPages/IndustriesWeServe";
import FAQSection from "./Components/InternalPages/FAQSection";
import DriverSection4 from "./Components/InternalPages/DriverSection4";
import DriverSection2 from "./Components/InternalPages/DriverSection2";

function DriverPartnerLogin() {
  return (
    <div className="minheight overflow-hidden">
      {/* Section 1 */}
      <section className="hero-section position-relative d-flex flex-column align-items-center justify-content-end">
        {/* Background */}
        <div className="image-section position-absolute top-0 start-0 w-100 h-100 z-n1">
          <img
            src={bg}
            alt="glare"
            className="hero-img w-100 h-100 object-fit-cover"
          />
          <div className="image-overlay position-absolute top-0 start-0 w-100 h-100"></div>
        </div>

        {/* Foreground Content */}
        <Container className="py-5 my-5">
          <Row className="justify-content-center">
            <Col xs={11}>
              <div
                className="shadow mt-5 p-4 p-md-5 rounded-4"
                style={{
                  background: "rgba(237, 241, 249, 0.7)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                }}
              >
                <Row className="g-5 align-items-center">
                  {/* Left Side */}
                  <Col xs={12} md={7}>
                    <img
                      src={front}
                      alt="Delivery Van"
                      className="w-100 rounded-4 mb-3"
                      style={{ height: "270px", objectFit: "cover" }}
                    />
                    <h2 style={{ fontWeight: "400" }} className="p-0 m-0">
                      Earn money delivering goods and packages.
                    </h2>
                    {/* <p className="text-secondary fw-light mb-0">
                      From warehouse to doorstep, Packky manages dispatch, routing, and
                      tracking without the need for your own fleet.
                    </p> */}
                  </Col>

                  {/* Right Side - Form */}
                  <Col xs={12} md={5}>
                    <div className="bg-white shadow p-4 rounded-4">
                      <h5 className="mb-4 text-center">
                        Fill Out For More Details
                      </h5>
                      <Form>
                        <Form.Group className="mb-3" controlId="formName">
                          <Form.Control
                            type="text"
                            placeholder="Enter your Name*"
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formCompany">
                          <Form.Control
                            type="text"
                            placeholder="Enter your Company Name*"
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPhone">
                          <Form.Control
                            type="text"
                            placeholder="Enter your Phone Number*"
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-4" controlId="formEmail">
                          <Form.Control
                            type="email"
                            placeholder="Enter your Email ID*"
                            required
                          />
                        </Form.Group>
                        <Button
                          type="submit"
                          className="w-100 text-white"
                          style={{ background: "#f39731", border: "none" }}
                        >
                          Get in Touch
                        </Button>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section2 */}
      <DriverSection2 />

      {/* What our driver partner say - Section 3 */}
      <section
        className="section3 overflow-hidden"
        style={{ position: "relative" }}
      >
        {/* Background image */}
        <img src={truckBg} alt="Background" className="background" />

        {/* Foreground content */}
        <div className="d-flex justify-content-between content-parent d-flex gap-5">
          <div
            style={{
              zIndex: 6,
              position: "relative",
              minWidth: "300px",
              width: "100vw",
            }}
            // style={{width: '100%'}}
            className="p-2 m-0 justify-content-center d-flex flex-column overflow-hidden align-items-center"
          >
            <h1 className="fw-200 fs-2 fs-md-2 fs-lg-1">
              What Our Driver Partner Say
            </h1>
            <p className="m-0 p-0 custom-paragraph mb-5" style={{}}>
              Hear how Packky is helping drivers earn better everyday
            </p>
            <img src={truck} alt="" className="truck-img" />
          </div>
          {/* 1st column of cards */}
          <div className=" d-flex gap-5 card-column1-parent default-scrollbar">
            {/* empty box */}
            <div
              className="p-3 rounded gap-2 d-flex flex-column box"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",

                minHeight: "150px",
                border: "1px solid white",
              }}
            >
              {" "}
            </div>

            {/* filled box */}
            <div
              className="p-3 rounded gap-2 d-flex flex-column box"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",

                minHeight: "100px",
                border: "1px solid white",
              }}
            >
              <div className="d-flex gap-3 ">
                <div className="">
                  <img
                    src={front}
                    alt="profile pic"
                    style={{
                      borderRadius: "50%",
                      height: "55px",
                      width: "55px",
                    }}
                  />
                </div>
                <div className="gap-1 d-flex justify-content-center align-items-start flex-column">
                  <h5 className="mb-0">Ajay Gupta</h5>
                  <p className="mb-0">Packky Driver Partner</p>
                </div>
              </div>
              <p
                className="mb-0"
                style={{ fontSize: "0.95rem", color: "#555" }}
              >
                "Packky helps me earn daily without the stress. The app is
                smooth, and payments are always on time."
              </p>
            </div>

            {/* empty box */}
            <div
              className="p-3 rounded gap-2 d-flex flex-column box"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                minHeight: "150px",
                border: "1px solid white",
              }}
            ></div>
          </div>
          {/* 2nd column of cards */}
          <div className=" d-flex card-column2-parent gap-5 default-scrollbar">
            {/* empty box */}
            <div
              className="p-3 rounded gap-2 d-flex flex-column box"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                minHeight: "100px",
                border: "1px solid white",
              }}
            >
              {" "}
            </div>

            {/* filled box */}
            <div
              className="p-3 rounded gap-2 d-flex flex-column box"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                minHeight: "100px",
                border: "1px solid white",
              }}
            >
              <div className="d-flex gap-3 ">
                <div className="">
                  <img
                    src={front}
                    alt="profile pic"
                    style={{
                      borderRadius: "50%",
                      height: "55px",
                      width: "55px",
                    }}
                  />
                </div>
                <div className="gap-1 d-flex justify-content-center align-items-start flex-column">
                  <h5 className="mb-0">Ajay Gupta</h5>
                  <p className="mb-0">Packky Driver Partner</p>
                </div>
              </div>
              <p
                className="mb-0"
                style={{ fontSize: "0.95rem", color: "#555" }}
              >
                "Packky helps me earn daily without the stress. The app is
                smooth, and payments are always on time."
              </p>
            </div>
            {/* filled box */}
            <div
              className="p-3 rounded gap-2 d-flex flex-column box"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",

                minHeight: "100px",
                border: "1px solid white",
              }}
            >
              <div className="d-flex gap-3 ">
                <div className="">
                  <img
                    src={front}
                    alt="profile pic"
                    style={{
                      borderRadius: "50%",
                      height: "55px",
                      width: "55px",
                    }}
                  />
                </div>
                <div className="gap-1 d-flex justify-content-center align-items-start flex-column">
                  <h5 className="mb-0">Ajay Gupta</h5>
                  <p className="mb-0">Packky Driver Partner</p>
                </div>
              </div>
              <p
                className="mb-0"
                style={{ fontSize: "0.95rem", color: "#555" }}
              >
                "Packky helps me earn daily without the stress. The app is
                smooth, and payments are always on time."
              </p>
            </div>

            {/* empty box */}
            <div
              className="p-3 rounded gap-2 d-flex flex-column"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",

                minHeight: "100px",
                border: "1px solid white",
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* More than just deliveries - Section 4 */}
      <DriverSection4 />

      <FAQSection />
    </div>
  );
}

export default DriverPartnerLogin;
